// @flow
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { NotFound } from '@finect/tabular-components/NotFound';
import type { TagType, StoreType, UserType } from '../../types';
import { getTags } from '../../store/tags/actions';
import TopicList from './TopicList';

const mapStateToProps = (state: StoreType) => ({
  tags: state.tags,
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ getTags }, dispatch)
});

type Props = {
  match: Object,
  tags: {
    [key: number]: TagType
  },

  actions: Object,

  location: {
    pathname: string,
    search: string,
    hash: string,
    state?: any,
    key?: string
  },

  user: UserType
};

class Topic extends React.Component<Props> {
  static loadInitialData(store, cookie) {
    return store.dispatch(getTags(cookie));
  }

  componentDidMount() {
    if (!Object.keys(this.props.tags).length) {
      this.props.actions.getTags();
    }
  }

  render() {
    const { match, tags, user, location } = this.props;
    const { tagId, tagSlug } = match.params;

    if (!Object.keys(tags).length) return null;

    const { pathname } = location;
    const path = pathname.replace(/\/\s*$/, '');
    const url = `/preguntas/temas/${tagId}/${tagSlug}`;

    if (!user.isLoggedIn && path === `${url}/siguiendo`) {
      return <Redirect to={url} />;
    }

    if (tags && !tags.hasOwnProperty(tagId)) {
      return (
        <Route
          render={props => (
            <NotFound
              message="Lo sentimos pero parece que este tema no existe."
              actionText="Volver a preguntas"
              redirectPath="/preguntas"
              {...props}
            />
          )}
        />
      );
    }

    const topicProps = {
      tagSlug,
      tag: tags[Number(tagId)] || {}
    };

    return (
      <Switch>
        <Route
          exact
          path={`/preguntas/temas/${tagId}/${tagSlug}/mas-activas`}
          render={props => <TopicList type="active" {...topicProps} {...props} />}
        />
        {/* <Route
          exact
          path={`/preguntas/temas/${tagId}/${tagSlug}/siguiendo`}
          render={props => <TopicList type="followedQuestions" {...topicProps} {...props} />}
        /> */}
        <Route
          exact
          path={`/preguntas/temas/${tagId}/${tagSlug}`}
          render={props => <TopicList type="latest" {...topicProps} {...props} />}
        />
        <Route
          render={props => (
            <NotFound
              actionText={`Volver a "${topicProps.tag.name}"`}
              redirectPath={`/preguntas/temas/${tagId}/${tagSlug}`}
              {...props}
            />
          )}
        />
      </Switch>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Topic);
